import api from '@/js/services/axios'

export const ALLOWED_CATEGORY_GROUP = 'GROUP'
export const ALLOWED_CATEGORY_INDIVIDUAL = 'INDIVIDUAL'
export const ALLOWED_CATEGORY_EVENT = 'EVENT'
export const ALLOWED_CATEGORY_CUSTOM_CLASSES = 'CUSTOM_CLASSES'

export const DURATION_TYPE_CALENDAR_MONTHS = 'CALENDAR_MONTHS'
export const DURATION_TYPE_MONTHS = 'MONTHS'
export const DURATION_TYPE_WEEKS = 'WEEKS'
export const DURATION_TYPE_DAYS = 'DAYS'

export default {
  /**
   * Get all publicly available memberships for an organization
   * @param {number} organizationId - The organization ID
   * @returns {Promise<Array>} List of publicly available memberships
   */
  getPublicMemberships: async (organizationId) => {
    return new Promise((resolve, reject) => {
      api.get(`public/v1/org/${organizationId}/memberships`)
        .then(response => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  /**
   * Get publicly available membership templates for an organization (for checkout choice)
   * @param {number} organizationId - The organization ID
   * @returns {Promise<Array>} List of membership templates (id, name, price, etc.)
   */
  getPublicMembershipTemplates: (organizationId) => {
    return api.get(`public/v1/org/${organizationId}/membership-templates`).then(response => response.data)
  },

  /**
   * Get publicly available membership templates that are valid for this class (API filters by class type / allowed class ids).
   * @param {number} organizationId - The organization ID
   * @param {number} classId - The class ID (r_class_id)
   * @returns {Promise<Array>} List of applicable membership templates
   */
  getPublicMembershipTemplatesForClass: (organizationId, classId) => {
    return api.get(`public/v1/org/${organizationId}/classes/${classId}/membership-templates`).then(response => response.data)
  }
}

